// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__YD7u4","productName":"Table_productName__dHtUq"};